


















import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import TabsNavigation from '@/componentsV2/molecules/TabsNavigation/TabsNavigation.vue';
import GeneralInfo from './Tabs/GeneralInfo.vue';
import HoursOfOperation from './Tabs/HoursOfOperation.vue';
import flagKeys from '@/constants/flagKeys';
import segmentIo from '@/utils/segment.io';
import isRemoteLoading from '@/utils/remote-loading';
import { IBusinessType } from '@/models/business';
import { BRAND_TAB_HOST_PATH } from '@/constants/host-paths';

const GENERAL_INFO_TAB = 'GeneralInfo';
const HOURS_TAB = 'HoursOfOperation';
// A native host screen, not a component of this page: picking it leaves the iframe.
const BRAND_TAB = 'BrandAndColor';

@Component({
  components: {
    Page,
    Typography,
    GeneralInfo,
    HoursOfOperation,
    TabsNavigation
  }
})
export default class BusinessProfileRoot extends Vue {
  // Class fields run on a proxy without `_i18n`, so reading the translated
  // `tabs` getter here would throw inside `data()` and blank the page.
  activeTabValue = GENERAL_INFO_TAB;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get openingHoursIsActive() {
    return this.flags.includes(flagKeys.openingHours);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get tabs() {
    const tabs = [
      {
        label: String(this.$t('business.businessProfile.tabs.generalInfo')),
        value: GENERAL_INFO_TAB
      },
      {
        label: String(this.$t('business.businessProfile.tabs.brandAndColor')),
        value: BRAND_TAB
      }
    ];

    if (
      this.openingHoursIsActive &&
      this.businessInfo.type !== IBusinessType.ONLINE
    )
      tabs.push({
        label: String(this.$t('business.businessProfile.tabs.operatingHours')),
        value: HOURS_TAB
      });
    return tabs;
  }

  changeTab(value: { label: string; value: string }) {
    segmentIo.track('Business Info | Changed Tab', {
      To: value.value,
      From: this.activeTabValue
    });

    if (value.value === BRAND_TAB) {
      this.openBrandTab();
      return;
    }

    this.activeTabValue = value.value;
  }

  openBrandTab() {
    if (isRemoteLoading()) {
      window.parent.postMessage(
        { type: 'portal-router-push', data: { path: BRAND_TAB_HOST_PATH } },
        '*'
      );
      return;
    }

    window.location.assign(BRAND_TAB_HOST_PATH);
  }

  created() {
    const requested = this.$route.query.tab;

    if (
      requested &&
      requested !== BRAND_TAB &&
      this.tabs.filter(tab => tab.value === requested)[0]
    ) {
      this.activeTabValue = requested as string;
    }
  }
}
